import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=829eb65c&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('829eb65c')) {
      api.createRecord('829eb65c', component.options)
    } else {
      api.reload('829eb65c', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=829eb65c&", function () {
      api.rerender('829eb65c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2o3vMBJpN8eFX/JS/cancellationPolicy.vue"
export default component.exports